import cn from 'classnames';
import type { PlateContentProps } from 'platejs/react';
import { PlateContainer, PlateContent } from 'platejs/react';

import styles from './Editor.module.scss';

export function EditorContainer({ className, ...props }: React.ComponentProps<'div'>) {
	return <PlateContainer className={cn(styles.container, className)} {...props} />;
}

export const Editor = ({
	className,
	disabled,
	ref,
	...props
}: PlateContentProps & { ref?: React.RefObject<HTMLDivElement | null> }) => {
	return (
		<PlateContent
			ref={ref}
			className={cn(styles.editor, className)}
			disabled={disabled}
			disableDefaultStyles
			{...props}
		/>
	);
};
